import { CoherenceTheme } from '@cseo/styles';
import { CommandBar, FontSizes, IStyle, mergeStyleSets } from '@fluentui/react';
import { CustomPicker } from './CustomPicker';
export const AdminSearchNormalPeoplePicker = styled(CustomPicker)`
    background-color: white;
    input {
        padding: 0px 12px;
        height: 28px;
    }
`;
export const SearchCommandBar = styled(CommandBar)`
    [role*='menubar'] {
        background-color: rgb(0, 120, 212);
        padding: 0;
    }
`;

export const HeaderSearchBoxStyles = mergeStyleSets({
    searchBox: {
        minWidth: '260px',
        selectors: {
            'div::after': { border: 'none', boxSizing: 'border-box' },
            'input:hover': {
                outLine: '0px',
                backgroundColor: 'rgb(242, 242, 242)',
                color: 'rgb(23, 23, 23)'
            },
            'input:focus': {
                outLine: '0px',
                backgroundColor: 'rgb(242, 242, 242)',
                color: 'rgb(23, 23, 23)'
            }
        }
    }
});
const buttonWidth = 48;
export const HeaderActionsStyles = mergeStyleSets({
    rightItemButton: {
        width: buttonWidth + 'px',
        height: buttonWidth + 'px',
        backgroundColor: 'transparent',
        selectors: {
            ':hover': {
                backgroundColor: CoherenceTheme.palette.themeDarkAlt,
                selectors: {
                    '.notification-badge': {
                        color: CoherenceTheme.palette.themeDarkAlt,
                        backgroundColor: CoherenceTheme.palette.white
                    }
                }
            },
            ':active': {
                backgroundColor: CoherenceTheme.palette.themeDarker,
                selectors: {
                    '.notification-badge': {
                        color: CoherenceTheme.palette.themeDarker,
                        backgroundColor: CoherenceTheme.palette.white
                    }
                }
            },
            '&.is-checked': {
                backgroundColor: CoherenceTheme.palette.themeDarker,
                selectors: {
                    '.notification-badge': {
                        color: CoherenceTheme.palette.themeDarker,
                        backgroundColor: CoherenceTheme.palette.white
                    }
                }
            }
        }
    } as IStyle,
    rightItemButtonOverflow: {
        width: '100%',
        height: buttonWidth + 'px',
        backgroundColor: CoherenceTheme.palette.white,
        color: CoherenceTheme.palette.neutralPrimary,
        textAlign: 'left'
    } as IStyle,
    rightItemButtonIcon: {
        color: CoherenceTheme.palette.white + ' !important',
        backgroundColor: 'transparent !important',
        fontSize: FontSizes.size16
    } as IStyle,
    rightItemButtonOverflowIcon: {
        color: CoherenceTheme.palette.neutralPrimary + ' !important',
        fontSize: FontSizes.size14,
        margin: '0px',
        paddingLeft: '14px'
    } as IStyle
});
